import cn from 'classnames';
import PropTypes from 'prop-types';

import { TermsAndConditionsSection } from 'components/checkout/caap/TermsConditionsAndNotes';
import { Spinner } from 'components/Loader';
import { toUSD } from 'helpers/NumberFormats';
import css from 'styles/components/checkout/caap/spc/placeOrderButtonSection.scss';

const PlaceOrderButtonSection = ({ isChargeSummary = false, isOrderBeingPlaced, isReadyToSubmit, onPlaceOrderClicked, orderTotal }, { testId }) => {
  const leftContainerStyles = cn(css.containerLeft, { [css.isChargeSummary]: isChargeSummary });
  const rightContainerStyles = cn(css.containerRight, { [css.isChargeSummary]: isChargeSummary });
  const topTermsAndConditionsStyles = cn(css.containerLeft, css.topTermsAndConditions, { [css.isChargeSummary]: isChargeSummary });

  return (
    <div className={css.placeOrderButtonSection}>
      <div className={topTermsAndConditionsStyles} data-test-id={testId('topTermsAndConditionsWrapper')}>
        <TermsAndConditionsSection />
      </div>

      <div className={leftContainerStyles}>
        <button
          type="button"
          className={css.placeOrderButton}
          onClick={onPlaceOrderClicked}
          disabled={!isReadyToSubmit}
          data-test-id={testId('placeOrderButton')}>
          {
            isOrderBeingPlaced
              ? <div>
                <Spinner />
                Placing Order...
              </div>
              : 'Place Your Order'
          }
        </button>
      </div>

      <div className={rightContainerStyles}>
        { orderTotal || orderTotal === 0
          ? <div className={css.orderTotalRow}>
            <h2 data-test-id={testId('orderTotalPlaceOrder')}>Order Total: {toUSD(orderTotal)}</h2>
          </div>
          : null
        }
        <div className={css.bottomTermsAndConditions} data-test-id={testId('bottomTermsAndConditionsWrapper')}>
          <TermsAndConditionsSection />
        </div>
      </div>
    </div>
  );
};

PlaceOrderButtonSection.contextTypes = {
  testId: PropTypes.func
};

export default PlaceOrderButtonSection;
